import React, { useState, useEffect } from "react";
import { MenuIcon, XIcon } from "@heroicons/react/outline";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const handleScroll = (e, id) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
    setIsOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
      setLastScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollY]);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-10 transition-transform duration-300 ${
        isVisible ? "translate-y-0" : "-translate-y-full"
      } navbar`}
    >
      <div className="bg-black bg-opacity-50">
        <div className="container mx-auto flex items-center justify-between py-4 px-4">
          <img src="/images/logo.jpg" alt="Logo" className="h-16 logoNav" />

          <ul className="hidden md:flex space-x-8 mx-auto">
            <li>
              <a
                href="#story"
                className="text-white hover:text-gray-300"
                onClick={(e) => handleScroll(e, "story")}
              >
                Story
              </a>
            </li>
            <li>
              <a
                href="#tokoonomics"
                className="text-white hover:text-gray-300"
                onClick={(e) => handleScroll(e, "tokoonomics")}
              >
                Tokoonomics
              </a>
            </li>
            <li>
              <a
                href="#roadmap"
                className="text-white hover:text-gray-300"
                onClick={(e) => handleScroll(e, "roadmap")}
              >
                Roadmap
              </a>
            </li>
            <li>
              <a
                href="#donation"
                className="text-white hover:text-gray-300"
                onClick={(e) => handleScroll(e, "donation")}
              >
                Donation
              </a>
            </li>
            <li>
              <a
                href="#faq"
                className="text-white hover:text-gray-300"
                onClick={(e) => handleScroll(e, "faq")}
              >
                Faq
              </a>
            </li>
          </ul>

          <a
            href="https://t.me/kspr_home_bot?start=refresh"
            target="_blank"
            rel="noopener noreferrer"
            className="font-bold button"
          >
            Buy $KOON
          </a>

          <button
            className="md:hidden text-white z-10 focus:outline-none navbutton"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? (
              <XIcon className="w-6 h-6" />
            ) : (
              <MenuIcon className="w-6 h-6" />
            )}
          </button>
        </div>

        <div
          className={`fixed top-0 left-0 h-full nav w-full bg-cover bg-center bg-no-repeat bg-black bg-opacity-90 transform transition-transform duration-300 ease-in-out ${
            isOpen ? "translate-x-0" : "-translate-x-full"
          } md:hidden`}
        >
          <img src="/images/claw_nav.png" alt="Logo" className="bg_navbar" />

          <ul className="flex flex-col items-start space-y-4 p-6">
            <li>
              <a
                href="#story"
                className="text-white hover:text-gray-300"
                onClick={(e) => handleScroll(e, "story")}
              >
                Story
              </a>
            </li>
            <li>
              <a
                href="#tokoonomics"
                className="text-white hover:text-gray-300"
                onClick={(e) => handleScroll(e, "tokoonomics")}
              >
                Tokoonomics
              </a>
            </li>
            <li>
              <a
                href="#roadmap"
                className="text-white hover:text-gray-300"
                onClick={(e) => handleScroll(e, "roadmap")}
              >
                Roadmap
              </a>
            </li>
            <li>
              <a
                href="#donation"
                className="text-white hover:text-gray-300"
                onClick={(e) => handleScroll(e, "donation")}
              >
                Donation
              </a>
            </li>
            <li>
              <a
                href="#faq"
                className="text-white hover:text-gray-300"
                onClick={(e) => handleScroll(e, "faq")}
              >
                Faq
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
